/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useQuery } from '@tanstack/react-query';
import QueryKeys from '../config';
import API from '../../../network';
import { UserByRoleRequest, UserByRole } from './types';

const useRoleUser = (payload: UserByRoleRequest, props?: { enabled?: boolean }) => {
  const { enabled } = props || { enabled: true };

  const {
    isLoading, data, error, refetch,
  } = useQuery<UserByRole[], Error>({
    queryKey: [QueryKeys.CLIENTS, payload],
    queryFn: async ({ queryKey }) => {
      const [, requestPayload] = queryKey as [string, UserByRoleRequest];
      return API.getInstance().getUsersByRole(requestPayload).then((response) => response.data);
    },
    refetchOnWindowFocus: false,
    initialData: [],
    enabled,
  });

  const userByRoleOptions = React.useMemo(
    () => data?.map((option) => ({ label: option.name, value: option.id })) || [],
    [data],
  );

  const userByRoleOptionsWithEmail = React.useMemo(
    () => data?.map((option) => (
      { label: option.name, subLabel: option.emailAddress, value: option.id })) || [],
    [data],
  );

  return {
    usersLoading: isLoading,
    userByRoleOptions,
    userByRoleOptionsWithEmail,
    data,
    error,
    fetchByRole: refetch,
  };
};

export {
  useRoleUser,
};
